import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Home } from "lucide-react";
import SEO from "@/components/SEO";
import { PHONE_DISPLAY, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
import { SITE_URL } from "@/lib/site";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-navy text-white flex flex-col" data-testid="page-404">
      <SEO
        title="Pagina non trovata | Carroattrezzi Roma H24"
        description="La pagina cercata non esiste, ma il nostro soccorso stradale è sempre disponibile. Chiama 06 9763 6222."
        canonical="https://carroassistenzaroma.com/"
      />
      <div className="absolute inset-0 hero-grid opacity-20 pointer-events-none" />
      <main className="relative flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-xl text-center">
          <p className="font-mono text-brand-orange text-sm tracking-[0.3em] font-bold">ERRORE 404</p>
          <h1 className="mt-3 font-display font-black text-5xl sm:text-6xl leading-tight text-shadow-strong">
            Pagina non trovata.
          </h1>
          <p className="mt-5 text-white/85 text-base sm:text-lg">
            Il nostro carro attrezzi però è sempre operativo, 24 ore su 24.
            Hai bisogno di assistenza? Chiamaci subito.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={PHONE_TEL_HREF}
              data-testid="not-found-call"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-brand-orange text-white font-bold px-6 py-4 text-lg animate-pulse-ring btn-glow-orange hover:brightness-110 transition"
            >
              <Phone className="h-5 w-5" />
              Chiama {PHONE_DISPLAY}
            </a>
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="not-found-whatsapp"
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-whatsapp text-white font-bold px-6 py-4 text-lg btn-glow-green hover:brightness-110 transition"
            >
              <MessageCircle className="h-5 w-5" />
              WhatsApp
            </a>
          </div>

          <Link
            to="/"
            data-testid="not-found-home"
            className="mt-8 inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-semibold"
          >
            <Home className="h-4 w-4" /> Torna alla home
          </Link>
        </div>
      </main>
    </div>
  );
}
